import ajaxService from '../../../services/ajaxService';
import FormErrorHandler from './FormErrorHandler';

class RequestTripReadAccessForm {
	/** @type {HTMLFormElement} */
	#form;
	/** @type {FormErrorHandler} */
	#formErrorHandler;
	
	constructor() {
		this.#form = document.querySelector('.request-trip-read-access-form');
		this.#formErrorHandler = new FormErrorHandler(this.#form);
		
		this.#init();
	}
	
	#init() {
		this.#initEvents();
	}
	
	#initEvents() {
		this.#form.addEventListener(
			'submit',
			(ev) => {
				this.#sendRequestTripReadAccessRequest();
				ev.preventDefault();
			}
		);
	}
	
	async #sendRequestTripReadAccessRequest() {
		this.#getElement('.submitButton').classList.add('disabled');
		this.#formErrorHandler.hideFeedbackMessages();
		
		const formData = new FormData(this.#form),
		      result   = await ajaxService.sendPost({
			      'url' : '/grant-trip-read-access',
			      'data': Object.fromEntries(formData)
		      });
		
		this.#handleResponse(result);
	}
	
	#handleResponse({response, xhr}) {
		const responseObject = typeof xhr === 'object' ? xhr : response;
		
		responseObject
			.then(() => {
				location.href = responseObject.responseJSON.redirectUrl;
			})
			.catch(() => {
				this.#formErrorHandler.handleErrorResponse(responseObject);
			});
	}
	
	/**
	 * @param {string} selector
	 * @returns {HTMLElement}
	 */
	#getElement(selector) {
		return this.#form.querySelector(selector);
	}
	
}

export default RequestTripReadAccessForm;